'use strict';

var processInclude = require('./util');

$(document).ready(function () {
    // processInclude(require('./common/datepicker'));
    processInclude(require('./contactUs/contactUs'));
    $('.selectpicker').selectpicker();
    $('.selectpicker').each(function() {
        $(this).css({
            display: 'none'
        });
        var label;
        // set button id for label
        if (this.labels.length > 0) {
            label = this.labels[0].innerText;
        } else {
            label = $(this).closest('.cc-form-group').find('.cc-label').html();
        }
        var $button = $(this).siblings('button');
        // var selectID = $(this).attr('id') + '_btn';
        // var labelID = $(this).attr('id') + '_lbl';
        // $(this).attr('aria-hidden', 'true');
        // $button.attr('id', selectID);
        $button.attr('aria-label', label);
        // $button.attr('aria-labelledby', selectID + ' ' + labelID);
        $(this).selectpicker('refresh');
        // fix voice over
        $(this).parent().find('.dropdown-toggle').removeAttr('role');
    });
});
